/* ==========================================================================

   MEGA MENU -- product panel



   v2. The first version kept Aurora's text columns and added thumbnails plus

   a spotlight card. Jeff's verdict: still boring to look at and to use. With

   only 44 shoppable listings, columns of links are mostly empty space -- so

   the panel now shows the products themselves as cards. For a store that

   sells photographs, the menu should look like a shop, not a sitemap.



   Cards are built at runtime from `/collections/<handle>/products.json`, so

   the menu tracks the catalog with no map to maintain. Options collapse to a

   single card via `window.PP_FAMILY_MEMBERS`, exactly like the collection

   grid does -- otherwise "Metal Wall Décor" alone would fill the panel with

   15 near-identical cards.



   ⚠ ALL SIX panels live in the DOM at once as siblings, all

   `display:block; visibility:visible`. Only OPACITY marks the open one, so

   every lookup is scoped to a panel.

   ========================================================================== */

(function () {
  /* ⛔ A FIXED products.json URL IS A CDN CACHE, NOT A LIVE READ. Shopify
     caches /collections/<h>/products.json hard, so this menu kept showing
     product names that no longer existed: after 243 size siblings were pulled
     out of the collections, the menu still listed "8 x 10 Print" (a size of
     the "Print" family, no longer browsable) alongside the family card.
     Fetched with cache:'reload' the same endpoint was already correct, which
     proves the data was fine and the URL was stale.
     A cache-buster on every hover would throw away the caching that makes this
     menu fast, so the key is the DAY: cached within a day, refreshed across
     one. Bump this if a catalog change needs to show up sooner. */
  var CATALOG_DAY = new Date().toISOString().slice(0, 10);


  'use strict';



  var MAX_CARDS = 8;



  /* ---- category -> collection, read from the nav itself -----------------

     This used to be two hardcoded maps keyed by the handleized nav TITLE.

     That key is derived from the label, so renaming a nav item silently

     desynced the panel: the lookup missed, `sourceOf(cat)` fell back to

     the category key, and the panel quietly fetched the wrong collection (or

     none). Exactly the failure mode that killed a nav drop-tier in

     pp-navfit.css, where a selector referenced the collection handle instead

     of the label-derived class and simply never matched.



     The nav item is a LINK. Its href already names the collection and its

     text is the label, so both facts are read from the DOM at runtime and

     neither can drift. The two non-obvious pairings the old map encoded --

     office-tech -> office, cards -> cards-calendars -- come through

     correctly because they are what the anchors actually point at. */

  var navCache = null;



  function navInfo() {

    if (navCache) return navCache;

    navCache = {};

    var items = document.querySelectorAll('a[class*="header__item--"]');

    for (var i = 0; i < items.length; i++) {

      var el = items[i];

      var key = /header__item--([a-z0-9-]+)/.exec(el.className);

      if (!key) continue;

      var href = el.getAttribute('href') || '';

      var handle = /\/collections\/([^/?#]+)/.exec(href);

      navCache[key[1]] = {

        /* fall back to the key so a nav item pointing somewhere unexpected

           still resolves to something rather than undefined */

        handle: handle ? handle[1] : key[1],

        label: (el.textContent || '').trim() || key[1]

      };

    }

    return navCache;

  }



  function sourceOf(cat) {

    var n = navInfo()[cat];

    return (n && n.handle) || cat;

  }



  function labelOf(cat) {

    var n = navInfo()[cat];

    return (n && n.label) || cat;

  }



  /* ⚠ RE-VERIFIED 2026-08-17 by opening each image. The previous list was

     written BEFORE Fujifilm's spec-sheet artwork landed and had gone stale —

     it still named six products, three of which are now perfectly fine, and

     I repeated it to Jeff as fact. Do not trust this list without looking.



     Still bad:

       6668  "12 oz. Insulated Wine Tumbler" -> image is a black FRAMED PRINT

       4042  "Photo Notepad"                 -> flat leaf-pattern sheet, no notepad

       8042  "8.5x11 Layflat Album"          -> flat panel, no album/spine visible



     Fixed since, and REMOVED from this list (they were being hidden for

     nothing): 6716 Pet Bed, 5107 Photo Notebook, 6374 Acrylic Square Magnet. */

  var SUPPRESS = {

    'mc-prgift-6668': 1,

    'mc-prgift-4042': 1,

    'mc-prgift-8042v2': 1

  };



  /* ⛔ PREFER THE TAG, NOT THE LIST ABOVE.

     The map is hand-maintained: it only exists because those six have wrong

     artwork from Fujifilm and needed suppressing before there was a mechanism.

     Anything excluded from FEATURED placements from now on should carry the

     Shopify tag `no-feature` instead — Jeff can then hide a product from the

     mega menu and the homepage bentos from the admin, with no code change and

     no risk of the list drifting out of step with the catalog.

     `/collections/<handle>/products.json` returns `tags`, so it costs nothing.

     (First use: the White Pet Bowl, which reads badly as a category face.) */

  var NO_FEATURE_TAG = 'no-feature';



  function isSuppressed(p) {

    if (SUPPRESS[p.handle]) return true;

    var t = p.tags;

    if (!t) return false;

    if (typeof t === 'string') t = t.split(',');

    for (var i = 0; i < t.length; i++) {

      if (String(t[i]).trim().toLowerCase() === NO_FEATURE_TAG) return true;

    }

    return false;

  }



  var CACHE = {};



  /* Placeholder cards, seeded into the template so the panel opens at its

     FINAL height. Previously the grid carried a guessed `min-height` that was

     dropped the moment the fetch resolved, so the panel visibly grew while you

     were looking at it -- that was the "janky opening". Same markup as a real

     card, so swapping content in causes no reflow at all. */

  var SKELETON = (function () {

    var out = "";

    for (var i = 0; i < 8; i++) {

      out +=

        '<span class="pp-mc pp-mc--skel" aria-hidden="true">' +

        '<span class="pp-mc__frame"></span>' +

        '<span class="pp-mc__title"></span>' +

        '<span class="pp-mc__price"></span>' +

        '</span>';

    }

    return out;

  })();



  function money(cents) {

    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');

  }



  function sized(url, w) {

    if (!url) return '';

    var u = url.indexOf('//') === 0 ? 'https:' + url : url;

    return u.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');

  }



  function esc(s) {

    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');

  }



  /* One card per family. A family is identified by its option count from

     PP_FAMILY_MEMBERS plus product_type -- the same signature the collection

     grid uses -- so 15 metal sizes collapse to one "Metal Wall Décor".

     ⚠ The badge says "N options", never "N sizes": mug families vary by

     COLOR (6 colors), magnets by finish, cards by set size. Only the count

     is known here, not what varies, so the wording must stay generic. */

  function listings(products) {

    var fam = window.PP_FAMILY_MEMBERS || {};

    var seen = {};

    var out = [];

    for (var i = 0; i < products.length; i++) {

      var p = products[i];

      if (isSuppressed(p)) continue;

      var n = fam[p.handle];

      if (n) {

        var key = n + '|' + (p.product_type || '');

        if (seen[key]) continue;

        seen[key] = 1;

      }

      out.push(p);

      if (out.length >= MAX_CARDS) break;

    }

    return out;

  }



  function load(collection) {

    if (CACHE[collection]) return CACHE[collection];

    CACHE[collection] = fetch('/collections/' + collection + '/products.json?limit=50&d=' + CATALOG_DAY, {

      headers: { Accept: 'application/json' }

    })

      .then(function (r) {

        return r.ok ? r.json() : null;

      })

      .then(function (j) {

        return j && j.products ? listings(j.products) : [];

      })

      .catch(function () {

        return [];

      });

    return CACHE[collection];

  }



  function cardHTML(p) {

    var img = (p.images && p.images[0] && p.images[0].src) || '';

    var price = p.variants && p.variants[0] ? Math.round(parseFloat(p.variants[0].price) * 100) : 0;

    var fam = window.PP_FAMILY_MEMBERS || {};

    var n = fam[p.handle];

    return (

      '<a class="pp-mc" href="/products/' + esc(p.handle) + '">' +

      '<span class="pp-mc__frame">' +

      (img ? '<img class="pp-mc__img" src="' + esc(sized(img, 400)) + '" alt="" loading="lazy">' : '') +

      (n > 1 ? '<span class="pp-mc__badge">' + n + ' options</span>' : '') +

      '</span>' +

      '<span class="pp-mc__title">' + esc(p.title) + '</span>' +

      '<span class="pp-mc__price">from ' + money(price) + '</span>' +

      '</a>'

    );

  }



  function fill(panel, cat) {

    if (panel.ppFilled) return;

    panel.ppFilled = true;

    var grid = panel.querySelector('.pp-mm__grid');

    if (!grid) return;

    load(sourceOf(cat)).then(function (items) {

      if (!items.length) {

        grid.innerHTML = '';

        return;

      }

      grid.innerHTML = items.map(cardHTML).join('');

    });

  }





  /* ⚠ Filling the panel after Aurora clones it is too late: the clone happens

     at the same moment the panel opens, so the grid visibly resizes while you

     are looking at it. Worse, a fixed 8-card skeleton makes categories with

     fewer listings SHRINK on fill (measured: Prints 600px -> 289px).



     So the cards are written into `template.content` BEFORE Aurora ever

     clones it. Every clone is then born complete and never changes height.

     The skeleton only shows if someone hovers within the first moment of page

     load, before the fetch lands. */

  function prefill(tpl, cat) {

    var grid = tpl.content.querySelector('.pp-mm__grid');

    if (!grid) return;

    load(sourceOf(cat)).then(function (items) {

      if (!items.length) return;

      grid.innerHTML = items.map(cardHTML).join('');

    });

  }



  /* listings() and cardHTML() both need PP_FAMILY_MEMBERS to collapse sizes

     into one card; without it a panel would show 15 near-identical metal

     prints. It ships as its own deferred asset, so wait for it briefly. */

  function whenFamilyMapReady(cb) {

    var tries = 0;

    (function poll() {

      if (window.PP_FAMILY_MEMBERS || tries > 40) return cb();

      tries++;

      setTimeout(poll, 50);

    })();

  }



  function categoryOf(tpl) {

    return (tpl.getAttribute('data-header-float-element-template') || '').replace(

      'HeaderDropdownMenu-',

      ''

    );

  }



  /* ---- rewrite each dropdown template once, at load ---------------------- */

  function enhance(tpl) {

    if (tpl.ppDone) return;

    tpl.ppDone = true;



    var frag = tpl.content;

    var cols = frag.querySelector('.mega-menu__columns');

    var inner = frag.querySelector('.mega-menu__inner-container');

    if (!cols || !inner) return;



    var cat = categoryOf(tpl);



    /* Aurora caps this container per panel (748px for three columns, 960 for

       four) from a rule that outranks even a (0,3,1) `!important`, so it is

       beaten inline. Set on the template, every clone inherits it. */

    cols.style.setProperty('width', '100%', 'important');

    cols.style.setProperty('max-width', 'none', 'important');



    /* Replace the link columns wholesale. */

    cols.classList.add('pp-mm__cols');

    cols.innerHTML =

      '<div class="pp-mm__grid" data-pp-cat="' + esc(cat) + '">' + SKELETON + '</div>' +

      '<a class="pp-mm__all" href="/collections/' + esc(sourceOf(cat)) + '">' +

      'Browse all ' + esc(labelOf(cat)) +

      '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true">' +

      '<path d="M2.5 8h11m-4.5-4.5L13.5 8 9 12.5" stroke="currentColor" ' +

      'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';

  }



  function init() {



  /* ---- kill the scroll-restore animation on drawer close ----------------

     Aurora locks scrolling by setting `position: fixed; top: -<scrollY>px`

     on <body>, then on close removes both and calls scrollTo() to put you

     back. But the theme also sets `html { scroll-behavior: smooth }`, so

     that restore ANIMATES: the page snaps down by the full scroll offset

     (measured: 900px at scrollY 900) and then visibly glides back over

     ~400ms. That is the "page jumps when it closes".



     Measured trace, closing at scrollY 900:

       0ms   top=1442  position:fixed  top:-900px

       589ms top=2342  position:relative        <- instant +900px snap

       589-990ms       2342 -> 1442             <- smooth scroll back



     Fix: while the lock is being released, force `scroll-behavior: auto` so

     the restore is instantaneous, then hand smooth scrolling back. Two rAFs

     is enough to cover the frame the scrollTo lands on.



     ⚠ Deliberately NOT `html { scroll-behavior: auto }` globally -- that

     would also make anchor links and back-to-top jump. This is scoped to the

     moment of release only, and covers the cart and search drawers too,

     since all three use the same `scroll-y-off` body class. */

  (function () {

    var root = document.documentElement;

    var locked = document.body.classList.contains('scroll-y-off');

    new MutationObserver(function () {

      var now = document.body.classList.contains('scroll-y-off');

      if (now === locked) return;

      locked = now;

      if (now) {

        /* ⚠ Set this on OPEN, not on close. Aurora's close sequence is

           (1) unset position:fixed  (2) scrollTo(savedY)  (3) remove the

           class -- so hooking the class REMOVAL fires after the scrollTo has

           already started animating and changes nothing. Measured: still 33

           displaced frames / 528ms. Engaging it while the menu is open means

           auto is already in force when the restore runs. */

        clearTimeout(root.__ppSb);

        root.style.scrollBehavior = 'auto';

      } else {

        /* Hand smooth scrolling back once the restore has definitely landed. */

        clearTimeout(root.__ppSb);

        root.__ppSb = setTimeout(function () {

          root.style.scrollBehavior = '';

        }, 700);

      }

    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  })();



  /* ---- animate the panel height when you move between categories --------

     Aurora already declares `transition: opacity, translate, visibility,

     height 0.17s` on the dropdown, but its height is `auto`, and auto is not

     interpolable -- so the transition never runs. With plain link lists the

     panels were all about the same height and nobody noticed. Our panels are

     product grids: 4 cards is one row (461px), 8 cards is two (772px), so

     moving from Prints to Home & Gifts resized the panel by 311px in a SINGLE

     frame. Measured, fully visible (opacity 1, visibility visible). That is

     the "janky" feeling.



     Note the same 311px snap also happens on OPEN, but there it is invisible

     -- measured at opacity 0 / visibility hidden -- so it is deliberately left

     alone rather than animated, which would add lag to every open.



     Fix: measure the height before and after the swap and animate between the

     two, matching Aurora's own 0.17s so it feels native.



     ⚠ Two things about HOW, both measured the hard way:



     1. Use the Web Animations API, not the CSS transition. Setting

        style.height = old, forcing a reflow, then setting the new value is the

        textbook trick, and it does work from a normal task -- but from inside

        the observer it does not fire at all. The animation is deterministic.



     2. Do the work synchronously in the observer callback, NOT in a rAF.

        MutationObserver callbacks run as microtasks, before the frame is

        painted. Deferring to rAF is one frame too late: the browser paints the

        snapped height first, so you get a 1-frame flash to the new size and

        THEN a smooth ramp -- measured 461 -> 772 -> 461 -> ramp. Worse than

        doing nothing. */

  (function () {

    /* Aurora may not have upgraded the element yet when init() runs. */

    (function find(tries) {

      var fe = document.getElementById('HeaderDropdownMenu');

      if (!fe) { if (tries < 40) setTimeout(function () { find(tries + 1); }, 50); return; }

      attach(fe);

    })(0);



    function attach(fe) {

      var last = 0;



      function settle() {

        var cs = getComputedStyle(fe);

        var shown = cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.5;



        /* If a previous animation is still running, start from where it

           actually is on screen, not from where it was headed -- otherwise

           fast hovering across the nav jumps. */

        var a = fe.__ppA;

        var from = a && a.playState === 'running' ? fe.getBoundingClientRect().height : last;

        if (a) a.cancel();

        var to = fe.getBoundingClientRect().height;



        /* Closed, or opening while still invisible: adopt silently. The same

           311px change happens on open, but at opacity 0 -- animating it there

           would only add lag to every open. */

        if (shown && from && Math.abs(to - from) > 4) {

          fe.__ppA = fe.animate(

            [{ height: from + 'px' }, { height: to + 'px' }],

            { duration: 170, easing: 'cubic-bezier(.4,0,.2,1)' }

          );

        }

        last = to;

      }



      /* ⚠ The switch is NOT a childList change. All six panels get cloned into

         the dropdown and then all six stay there; Aurora picks one by toggling

         a `visible` (and `inert`) attribute on its .header__dropdown-menu. A

         childList-only observer never fires once -- measured 0 mutations

         across a full category switch. */

      new MutationObserver(settle).observe(fe, {

        childList: true,

        subtree: true,

        attributes: true,

        attributeFilter: ['visible', 'inert'],

      });

    }

  })();



    var tpls = document.querySelectorAll('template[data-header-float-element-template]');

    for (var i = 0; i < tpls.length; i++) enhance(tpls[i]);



    whenFamilyMapReady(function () {

      for (var k = 0; k < tpls.length; k++) {

        prefill(tpls[k], categoryOf(tpls[k]));

      }

    });



    var dd = document.getElementById('HeaderDropdownMenu');

    if (!dd) return;



    /* Warm the fetch as the cursor reaches the top-level item, so the panel

       is populated by the time it finishes opening. */

    var navItems = document.querySelectorAll('[class*="header__item--"]');

    for (var n = 0; n < navItems.length; n++) {

      (function (el) {

        var m = /header__item--([a-z0-9-]+)/.exec(el.className);

        if (!m || !navInfo()[m[1]]) return;

        el.addEventListener('pointerenter', function () {

          load(sourceOf(m[1]));

        });

      })(navItems[n]);   /* ⚠ was navItems[i] -- wrong loop variable */

    }



    function activate() {

      var grids = dd.querySelectorAll('.pp-mm__grid');

      for (var g = 0; g < grids.length; g++) {

        var grid = grids[g];

        var panel = grid.closest('.header__dropdown-menu');

        if (panel) fill(panel, grid.getAttribute('data-pp-cat'));

      }

    }



    /* Aurora clones the templates in on first open. React only to nodes

       carrying our markup -- fill() mutates this subtree itself, and

       reacting to that would spin the observer against its own writes. */

    new MutationObserver(function (recs) {

      for (var r = 0; r < recs.length; r++) {

        var added = recs[r].addedNodes;

        for (var x = 0; x < added.length; x++) {

          var node = added[x];

          if (

            node.nodeType === 1 &&

            (node.matches('.pp-mm__grid') || node.querySelector('.pp-mm__grid'))

          ) {

            activate();

            return;

          }

        }

      }

    }).observe(dd, { childList: true, subtree: true });



    activate();

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }

})();

